// localStorage can throw (private mode, blocked site data); nothing here is critical.
export function load(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function save(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* ignore */
  }
}

export const hostKeyFor = (code: string) => `meet.hostKey.${code}`;
